/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Rationale_SessionInputs */

const en_us2_push_rationale_session = /** @type {(inputs: Push_Rationale_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session summary, right after you finish.`)
};

const pt_br2_push_rationale_session = /** @type {(inputs: Push_Rationale_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O resumo do treino, logo depois que você termina.`)
};

const es_419_push_rationale_session = /** @type {(inputs: Push_Rationale_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El resumen del entrenamiento, justo después de terminar.`)
};

const pt_pt2_push_rationale_session = /** @type {(inputs: Push_Rationale_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O resumo do treino, logo depois de terminares.`)
};

const fr_fr2_push_rationale_session = /** @type {(inputs: Push_Rationale_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le résumé de ta séance, juste après l'avoir terminée.`)
};

const de_de2_push_rationale_session = /** @type {(inputs: Push_Rationale_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Trainingszusammenfassung, direkt nach dem Training.`)
};

const it_it2_push_rationale_session = /** @type {(inputs: Push_Rationale_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il riepilogo della sessione, appena finisci.`)
};

/**
* | output |
* | --- |
* | "Your session summary, right after you finish." |
*
* @param {Push_Rationale_SessionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_rationale_session = /** @type {((inputs?: Push_Rationale_SessionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Rationale_SessionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_rationale_session(inputs)
	if (locale === "es-419") return es_419_push_rationale_session(inputs)
	if (locale === "pt-PT") return pt_pt2_push_rationale_session(inputs)
	if (locale === "fr-FR") return fr_fr2_push_rationale_session(inputs)
	if (locale === "de-DE") return de_de2_push_rationale_session(inputs)
	if (locale === "it-IT") return it_it2_push_rationale_session(inputs)
	return en_us2_push_rationale_session(inputs)
});
export { push_rationale_session as "push.rationale_session" }